/**
 * Bidirectional mapping between tag semantic color names (stored in the
 * backend, e.g. `"red"`) and the CSS design-token strings used by the UI
 * color picker (e.g. `"var(--color-semantic-bg-tag-red)"`).
 *
 * Keep this in sync with the palette defined in TagFormPage (`PRESET_COLORS`).
 */

const TAG_TOKEN_PREFIX = "var(--color-semantic-bg-tag-";

/**
 * Converts a semantic color name from the API/store into the CSS var token
 * used for rendering (background colors, picker selection, etc.).
 *
 * Returns `null` when `name` is null / undefined / empty.
 */
export function colorNameToToken(name: string | null | undefined): string | null {
  if (!name) return null;
  return `${TAG_TOKEN_PREFIX}${name})`;
}

/**
 * Extracts the semantic color name from a CSS var token.
 * Returns `null` when `token` is null / undefined / empty or doesn't match
 * the expected prefix (e.g. arbitrary CSS colors are left as-is by the caller).
 */
export function tokenToColorName(token: string | null | undefined): string | null {
  if (!token) return null;
  if (!token.startsWith(TAG_TOKEN_PREFIX)) return null;
  return token.slice(TAG_TOKEN_PREFIX.length, -1);
}
